import { useEffect } from 'react';

export default function useInitCookies() {
  const init = async () => {
    const [{ initSentry }, { initHotjar }] = await Promise.all([
      import('initSentry'),
      import('initHotjar'),
    ]);

    initSentry();
    initHotjar();
  };

  const removeDialogUnderlay = () => {
    document.getElementById('CybotCookiebotDialogBodyUnderlay')?.remove();
  };

  useEffect(() => {
    window.addEventListener('CookiebotOnAccept', init as EventListener);
    window.addEventListener('CookiebotOnAccept', removeDialogUnderlay);
    window.addEventListener('CookiebotOnDecline', removeDialogUnderlay);

    return () => {
      window.removeEventListener('CookiebotOnAccept', init as EventListener);
      window.removeEventListener('CookiebotOnAccept', removeDialogUnderlay);
      window.removeEventListener('CookiebotOnDecline', removeDialogUnderlay);
    };
  }, []);
}
